export default class TransitionStylesManager {
  constructor() {
    this.elements = new Map();
  }
  registerTransitionStyle(element, property) {
    let properties = this.elements.get(element);
    if (!properties) {
      properties = new Set();
      this.elements.set(element, properties);
    }
    properties.add(property);
  }
  removeTransitionStyles(element) {
    const styles = this.elements.get(element);
    if (styles) {
      styles.forEach(style => element.style.removeProperty(style));
      this.elements.delete(element);
    }
  }
  get(element) {
    return this.elements.get(element);
  }
  clearTransitionStyles() {
    for (const element of this.elements.keys()) {
      this.removeTransitionStyles(element);
    }
  }
}